import { render } from "./AmountView.vue?vue&type=template&id=1677935e"
import script from "./AmountView.vue?vue&type=script&lang=js"
export * from "./AmountView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/apps/acquiring_front_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__